






























import { Vue, Component, Prop } from "vue-property-decorator";
import Cookies from "js-cookie";
import Button from "@/common/components/atoms/Button.vue";
import IconAlert from "@/common/components/icons/IconAlert.vue";
import meta from "@/general/store/modules/meta";
import auth from "@/general/store/modules/auth";
import AuthStorage from "@/general/utils/auth";

@Component({
  components: {
    Button,
    IconAlert
  }
})
export default class ErrorAuth extends Vue {
  @Prop({ type: Boolean, required: false, default: false }) error!: boolean;

  get redirectUrl() {
    // 戻り先 url の設定が必要
    return (
      process.env.VUE_APP_AUTH_FACADE +
      "?callback_authorization_start_uri=" +
      process.env.VUE_APP_API_DOMAIN +
      "/v1/top/auth-start"
    );
  }
  get title() {
    const metaTitle = process.env.VUE_APP_PAGE_TITLE;
    return metaTitle;
  }

  get currentHref() {
    return window.location.href;
  }
  async mounted() {
    console.log("mouted");
    await meta.setDocumentTitle("お使いのアカウントはご利用いただけません。");
  }
}
